<div class="ui container">
    <div class="ui secondary pointing menu">
        <a routerLink="/elements" routerLinkActive="active" class="item">Elements</a>
        <a routerLink="/collections" routerLinkActive="active" class="item">Collections</a>
        <a routerLink="/views" routerLinkActive="active" class="item">Views</a>
        <a routerLink="/mods" routerLinkActive="active" class="item">Mods</a>
    </div>
    <div class="ui segment">
        <router-outlet></router-outlet>
    </div>
</div>


